import React from "react";
import { EditContainer, Hyperlink } from "./styles";

const Edit = ({ clickHandler }) => {
  return (
    <EditContainer onClick={clickHandler}>
      <Hyperlink>Edit</Hyperlink>
    </EditContainer>
  );
};

export default Edit;
